import types from './types';
import {
  getUser,
  login as _login,
  logout as _logout,
  validateApplicationRole as _validateApplicationRole,
  clearCache as _clearCache,
} from '@/core/auth';
import { getUserMenu, getAdditionalProfileInfo } from '../api';
import { USER_MENU_APP_SESSION_KEY } from '@/config';

export default {
  async init(context) {
    const { state, commit } = context;
    try {
      const user = await getUser(); //This always call for refresh token information.
      commit(types.SET_USER, user);

      if (state.userHasValidRole === null) {
        //Validate rol here
        const hasValidRole = await _validateApplicationRole().then((resp) => {
          return resp.data;
        });

        if (!hasValidRole) {
          this.logout({ state, commit });
          return;
        }

        commit(types.SET_USER_HAS_VALID_ROLE, hasValidRole);
        sessionStorage.setItem(
          'user-has-valid-role',
          JSON.stringify(hasValidRole)
        );
      }

      if (
        state.user &&
        (!state.userMenu || !state.companies || !state.permissions)
      ) {
        const [userMenu, additionalProfileInfo] = await Promise.all([
          await getUserMenu(),
          await getAdditionalProfileInfo(),
        ]);

        if (userMenu && userMenu.length) {
          commit(types.SET_MENU, userMenu);
          sessionStorage.setItem(
            USER_MENU_APP_SESSION_KEY,
            JSON.stringify(userMenu)
          );
          context.dispatch('$_common/getCurrentAcademicYear', null, {
            root: true,
          });
        }

        if (additionalProfileInfo) {
          const { companies, permissions, userProfile } = additionalProfileInfo;

          sessionStorage.setItem(
            'agreement-completed',
            userProfile.completeUserAgreement
          );

          sessionStorage.setItem(
            'profile-update-flag',
            !userProfile.isProfileUpdated
          );

          commit(types.SET_COMPANIES, companies);
          sessionStorage.setItem('user-companies', JSON.stringify(companies));

          commit(types.SET_PERMISSIONS, permissions);
          sessionStorage.setItem(
            'user-permissions',
            JSON.stringify(permissions)
          );
        }
      }
    } catch (err) {
      /* eslint-disable no-debugger, no-console */
      console.error(err);
      commit(types.SET_USER, null);
      commit(types.SET_MENU, null);
      commit(types.SET_PERMISSIONS, null);
      commit(types.SET_COMPANIES, null);
      commit(types.SET_USER_HAS_VALID_ROLE, null);
      sessionStorage.removeItem(USER_MENU_APP_SESSION_KEY);
      sessionStorage.removeItem('user-permissions');
      sessionStorage.removeItem('user-companies');
      sessionStorage.removeItem('current-academic-year');
      sessionStorage.removeItem('user-has-valid-role');
    }
  },
  async clearSession({ commit }) {
    commit(types.SET_USER_HAS_VALID_ROLE, null);

    sessionStorage.removeItem(USER_MENU_APP_SESSION_KEY);
    sessionStorage.removeItem('user-permissions');
    sessionStorage.removeItem('user-companies');
    sessionStorage.removeItem('current-academic-year');
    sessionStorage.removeItem('user-has-valid-role');

    sessionStorage.clear();
    await _clearCache();
  },
  login() {
    _login();
  },

  logout({ state, dispatch }) {
    let logoutId = state.user.profile.sub;
    _logout();
    dispatch('clearSession').then(function() {
      /* Señor FORCE */
      let urlLogout = process.env.VUE_APP_URL_AUTH;
      urlLogout += process.env.VUE_APP_ACR_URL_LOGOUT;
      urlLogout += '/?logoutid=' + logoutId;
      urlLogout +=
        '&redirectUrl=' + process.env.VUE_APP_URL_AUTH_POST_LOGOUT_REDIRECT_URI;
      window.location.replace(urlLogout);
    });
  },

  setMenu(context, menus) {
    context.commit(types.SET_MENU, menus);
    sessionStorage.setItem(USER_MENU_APP_SESSION_KEY, JSON.stringify(menus));
    sessionStorage.setItem('user-siteMap', JSON.stringify(menus));
  },
};
